import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class CurrencyExchangeRateService {
    private baseApiUrl: string;

    constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
        this.baseApiUrl = configurationService.BaseApiUrl;
    }
    getCurrencyCode(forMaintenance: boolean = false): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `currency?isMaintenance=${forMaintenance}`).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getFiltered(filter: string, pageIndex: number, pageSize: number,
        sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

        const params = {
            filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
        };

        return this.httpClient.post(this.baseApiUrl + 'currencyexchangerate/filter', params).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getAll(forMaintenance: boolean = false): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `currencyexchangerate?isMaintenance=${forMaintenance}`).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getCountryCode(forMaintenance: boolean = false): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `currencyexchangerate/getAllCountryCode?isMaintenance=${forMaintenance}`).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getById(id: number, forMaintenance: boolean = false): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `currencyexchangerate/${id}?isMaintenance=${forMaintenance}`).pipe(
            map((res: Response) => this.addCurrencyDisplayData(res)),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    create(currency: any): Observable<any> {
        return this.httpClient.post(this.baseApiUrl + `currencyexchangerate`, currency).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    update(id: number,currency: any): Observable<any> {
        return this.httpClient.put(this.baseApiUrl + `currencyexchangerate/${id}`, currency).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    authorise(id: number): Observable<any> {
        return this.httpClient.post(this.baseApiUrl + `currencyexchangerate/authorise`, id).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    delete(id: number): Observable<any> {
        return this.httpClient.delete(this.baseApiUrl + `currencyexchangerate/${id}`).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    addCurrencyDisplayData(currency: any): any {
        currency.displayData = `${currency.name} - ${currency.code}`;
        return currency;
    }
     getCurrecyExchangeRate(currencyCode1: string, currencyCode2: string): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `currencyexchangerate/currencyCode?currencyCode1=${currencyCode1}&currencyCode2=${currencyCode2}`).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

}
